import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { IRefreshToken } from "src/app/model/custom/IAuth";
import { environment } from "../../../environments/environment";

@Injectable({
	providedIn: "root",
})
export class OauthService {
	private http: HttpClient = inject(HttpClient);

	GetOauthURL(domain: string, returnUrl?: string) {
		return this.http.get(
			`${environment.apiURL}/user/oauth-url?domain=${domain}&returnUrl=${returnUrl ?? ""}`,
		);
	}
	ExchangeCodeForToken(code: string) {
		return this.http.post(`${environment.apiURL}/user/oauth-token`, { code });
	}
	RefreshToken(data: IRefreshToken) {
		return this.http.post(`${environment.apiURL}/user/oauth-refresh-token`, data);
	}
	Logout(username) {
		return this.http.put(`${environment.apiURL}/company/logout`, { username });
	}
}
